import React, { useRef, useState } from "react";
import { ImagePlus, Loader2, X, Check } from "lucide-react";
import { toast } from "sonner";
import { api, apiError, thumbUrl } from "@/api";

const stickerPath = (s) => (s.variations && s.variations[0] ? s.variations[0].storage_path : s.storage_path);

export function PackCoverField({ value, stickers, onChange }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/admin/packs/cover", fd);
      onChange(r.data.storage_path);
    } catch (e) { toast.error(apiError(e)); } finally { setUploading(false); if (inputRef.current) inputRef.current.value = ""; }
  };

  return (
    <div className="space-y-2" data-testid="pack-cover-field">
      <p className="text-sm font-medium text-[#2C2A29]">Imagem de capa</p>
      <div className="flex items-center gap-3">
        <div className="h-20 w-20 shrink-0 rounded-2xl sticker-canvas flex items-center justify-center overflow-hidden border border-dashed border-[#E8CFD1]">
          {value ? (
            <img src={thumbUrl(value)} alt="Capa" data-testid="pack-cover-preview" className="h-[85%] w-[85%] object-contain" />
          ) : (
            <span className="text-[10px] text-center text-[#7A7571] px-1" data-testid="pack-cover-auto">Automática</span>
          )}
        </div>
        <div className="flex flex-col gap-2">
          <button type="button" onClick={() => inputRef.current && inputRef.current.click()} disabled={uploading} data-testid="pack-cover-upload" className="inline-flex items-center gap-2 h-9 px-4 rounded-full bg-[#F7EBEC] text-[#B07A7F] text-sm font-medium hover:bg-[#EFD9DB] transition-colors disabled:opacity-70">
            {uploading ? <Loader2 size={15} className="animate-spin" /> : <ImagePlus size={15} />} Carregar imagem
          </button>
          {value && (
            <button type="button" onClick={() => onChange("")} data-testid="pack-cover-remove" className="inline-flex items-center gap-1.5 text-xs text-[#7A7571] hover:text-[#C0555A] transition-colors">
              <X size={13} /> Remover (usar a 1ª figurinha)
            </button>
          )}
        </div>
        <input ref={inputRef} type="file" accept="image/png,image/jpeg,image/webp,image/heic" className="hidden" data-testid="pack-cover-input" onChange={(e) => upload(e.target.files[0])} />
      </div>
      {stickers.length > 0 && (
        <div>
          <p className="text-xs text-[#7A7571] mb-1.5">Ou escolha uma figurinha do pack:</p>
          <div className="flex gap-2 overflow-x-auto pb-1" data-testid="pack-cover-stickers">
            {stickers.map((s) => {
              const path = stickerPath(s);
              const active = value === path;
              return (
                <button type="button" key={s.id} onClick={() => onChange(path)} data-testid={`pack-cover-pick-${s.id}`} className={`relative h-14 w-14 shrink-0 rounded-xl sticker-canvas flex items-center justify-center border-2 transition-colors ${active ? "border-[#C58B90]" : "border-transparent hover:border-[#E8CFD1]"}`}>
                  <img src={thumbUrl(path)} alt={s.name} loading="lazy" className="h-[80%] w-[80%] object-contain" />
                  {active && <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-[#C58B90] text-white flex items-center justify-center"><Check size={12} /></span>}
                </button>
              );
            })}
          </div>
        </div>
      )}
      <p className="text-[11px] text-[#7A7571]">Aparece na Home, nos Packs e no banner da coleção. Sem capa, usa a 1ª figurinha do pack.</p>
    </div>
  );
}
